import React, { useState } from 'react';
import { hoyIso } from '../../utils/calendarioUtils';
import { informarPuntosAplazado } from '../../services/aplazamientoService';
import { construirSets, validarSets } from './aplazamientoUtils';

const FILAS_VACIAS = [1, 2, 3].map(() => ({ local: '', visitante: '' }));

// Puntos de un aplazado ya recuperado. Quedan propuestos: los confirma el comité.
export default function InformarPuntos({ partido, jugadorId, onGuardado }) {
  const [filas, setFilas] = useState(FILAS_VACIAS);
  const [fechaJugado, setFechaJugado] = useState(hoyIso());
  const [error, setError] = useState(null);
  const [guardando, setGuardando] = useState(false);

  const cambiar = (i, campo, valor) =>
    setFilas((fs) => fs.map((f, j) => (j === i ? { ...f, [campo]: valor } : f)));

  const enviar = async (e) => {
    e.preventDefault();
    const sets = construirSets(filas);
    const problema = validarSets(sets);
    if (problema) { setError(problema); return; }
    setGuardando(true);
    setError(null);
    try {
      await informarPuntosAplazado(partido.partidoId, { sets, fechaJugado, jugadorId });
      onGuardado();
    } catch (err) {
      setError(err.message || 'No se pudieron enviar los puntos.');
      setGuardando(false);
    }
  };

  return (
    <form className="ap-puntos" onSubmit={enviar}>
      <p className="ap-ayuda">
        Local: <strong>{partido.local}</strong> · Visitante: <strong>{partido.visitante}</strong>. El comité revisará y confirmará los puntos.
      </p>
      {filas.map((f, i) => (
        <div className="ap-set" key={i}>
          <span>Set {i + 1}{i === 2 ? ' (si lo hubo)' : ''}</span>
          <input type="number" min="0" aria-label={`Set ${i + 1}, puntos del local`} value={f.local} onChange={(e) => cambiar(i, 'local', e.target.value)} />
          <span aria-hidden="true">-</span>
          <input type="number" min="0" aria-label={`Set ${i + 1}, puntos del visitante`} value={f.visitante} onChange={(e) => cambiar(i, 'visitante', e.target.value)} />
        </div>
      ))}
      <div className="ap-set">
        <label htmlFor={`ap-fecha-${partido.partidoId}`}>Fecha jugado</label>
        <input id={`ap-fecha-${partido.partidoId}`} type="date" max={hoyIso()} value={fechaJugado} onChange={(e) => setFechaJugado(e.target.value)} />
      </div>
      {error && <p className="msg-error" role="alert">{error}</p>}
      <button type="submit" className="btn btn-primary btn-sm" disabled={guardando}>
        {guardando ? 'Enviando…' : 'Enviar puntos'}
      </button>
    </form>
  );
}
